/**
 * Ícone de gravação: um ponto vermelho que pulsa, no canto do vídeo, para quem está na chamada (atendente e
 * convidado) saber que algo está sendo gravado (a transcrição). Só aparece com o transcritor da Jev na sala, ou
 * seja, quando de fato está gravando.
 *
 * O ponto sozinho não diz o que é, então ele traz uma dica visível, no hover E no foco (teclado e toque: tocar o ponto o
 * foca). É CSS dentro do próprio ícone, de propósito: o tooltip do Radix vai para o `body` da janela principal, e a sala
 * também roda na janela flutuante (outro documento), onde ele apareceria no lugar errado. O `title` nativo não serve: demora,
 * não abre por teclado nem por toque, e duplicaria a dica.
 */
import { useTranscriberPresent } from './useTranscriberPresence';

export const RECORDING_LABEL = 'Esta chamada está sendo transcrita';

/** Só o desenho (sem hooks). */
export function RecordingIndicatorView() {
    return (
        <span
            role="img"
            aria-label={RECORDING_LABEL}
            tabIndex={0}
            data-recording-indicator=""
            className="group pointer-events-auto relative inline-flex h-6 w-6 shrink-0 cursor-help items-center justify-center rounded-full bg-black/60 outline-none focus-visible:ring-2 focus-visible:ring-cyan-300"
        >
            <span aria-hidden="true" className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-60 motion-reduce:animate-none" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" />
            </span>
            <span
                role="tooltip"
                data-recording-tooltip=""
                className="pointer-events-none absolute left-full top-1/2 z-20 ml-2 -translate-y-1/2 whitespace-nowrap rounded-md bg-black/90 px-2.5 py-1.5 text-xs font-medium text-neutral-50 opacity-0 shadow-lg ring-1 ring-white/10 transition-opacity duration-150 group-hover:opacity-100 group-focus:opacity-100"
            >
                {RECORDING_LABEL}
            </span>
        </span>
    );
}

export function RecordingIndicator() {
    return useTranscriberPresent() ? <RecordingIndicatorView /> : null;
}
